import {Ability, AbilityBuilder} from '@casl/ability'
import * as routes from '../router/routes';

const ability = new Ability();
export default ability;

export function defineAbilitiesFor(profile) {
    const {rules, can} = AbilityBuilder.extract();
    for (const key in routes) {
        if (routes[key].profiles && routes[key].profiles.includes(profile)) {
            can('manage', routes[key].name);
        }
    }
    ability.update(rules);
}



// WEBPACK FOOTER //
// ./src/util/abilities.js